module.exports = __webpack_public_path__ + "images/graphic-header-3@2x_197b7217305ac2cd8656af79038ae758.png";